module.exports = __webpack_public_path__ + "img/engraving-2@2x.637cd47.webp";